module.exports = __webpack_public_path__ + "static/img/transition_3.f452da7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/transition_3.png
// module id = bn+o
// module chunks = 0